import React, {
  useState,
  useEffect,
} from 'react';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { fetchUsers } from 'src/actions/idActions';
import { fetchCategory, fetchUsers5 } from 'src/actions/mgmtSelectValueAction';

import { fetchInvoice } from 'src/actions/mgmtInvoiceAction';
import Results1 from '../InvoiceListView/List';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));

function InvoiceListView() {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const [id, setId] = React.useState('');
  const customer15 = useSelector(
    (state) => state?.user?.users1
  );
  
  const userTy = useSelector(
    (state) => state?.account?.user?.userType
  );

  const customerId = useSelector(
    (state) => state?.account?.user?.customerId
  );

  const userType = userTy

  const selectedCustomerId = (id) ? id : customer15;


  const handleChange = (event) => {
    setId(event.target.value);
    dispatch(fetchUsers5(event.target.value));
    dispatch(fetchInvoice(event.target.value));
  };

  const customerIdList = useSelector(
    (state) => state?.user?.users?.customerList
  );

   const cid = (userType === "SUPER_ADMIN") ? selectedCustomerId : customerId;
  useEffect(() => {
    dispatch(fetchInvoice(cid));
  }, []);

  useEffect(() => {
    dispatch(fetchUsers());
  }, []);

  const invoiceList = useSelector(
    (state) => state?.invoice?.invoice
  );
  const length = invoiceList.length
  
  if (!customerIdList) {
    return null;
  }

  return (
    <Page
      className={classes.root}
      title="Invoice List"
    >
      <Container maxWidth={false}>
        <Header />
        <br />
        {
          userType !== "ADMIN"  && userType !== "SUPPORT"  ?
            <Card style={{ marginLeft: "0em", maxWidth: '1200px', maxHeight: '400px' }}>
              <CardContent>
                <Grid container spacing={2}> <Grid item xs={12} sm={12}>
                  <FormControl fullWidth>
                    <div>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Select CustomerId *</InputLabel>
                        <Select
                          labelId="demo-simple-select-label *"
                          // id="demo-simple-select"
                          label="Select CustomerId *"
                          onChange={handleChange}
                          value={selectedCustomerId}
                        >
                          {customerIdList.map((idlist) => (
                            <MenuItem value={idlist.customerId}>
                              {idlist.customerId}
                              {"..."}
                              {idlist.businessName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </FormControl>
                </Grid>
                </Grid>
              </CardContent>
            </Card> :
            <Box />
          // <Grid item xs={12}>
          //   <TextField
          //     fullWidth
          //     label="Customer Id"
          //     name="customerId"
          //     onChange={handleChange}
          //     value={customerId}
          //     variant="outlined"
          //   />
          // </Grid>
        }
        <br />
        <Results1 invoiceList={invoiceList} length={length} selectedCustomerId={selectedCustomerId}/>
      </Container>
    </Page>
  );
}

export default InvoiceListView;

